import { getExecutedActions, getActionName, getExecutionStatus, getResponse, getParameters, getCompletedAt } from 'conversations-message-history/customer-agent-action-execution-message/operators/getters';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { ViewIcon } from 'foundations-assets';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { View } from 'foundations-components/transitional/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function getStatusMessage(executionStatus) {
  switch (executionStatus) {
    case 'SUCCESS':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'conversations-inbox-message-history.customer-agent-action-execution-message.success'
      });
    case 'SERVER_ERROR':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'conversations-inbox-message-history.customer-agent-action-execution-message.serverError'
      });
    case 'CLIENT_ERROR':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'conversations-inbox-message-history.customer-agent-action-execution-message.clientError'
      });
    case 'UNKNOWN_ERROR':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'conversations-inbox-message-history.customer-agent-action-execution-message.unknownError'
      });
    default:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'conversations-inbox-message-history.customer-agent-action-execution-message.unknownError'
      });
  }
}
const actionMessage = executedAction => {
  const actionName = getActionName(executedAction);
  const executionStatus = getExecutionStatus(executedAction);
  const completedAt = getCompletedAt(executedAction);
  const response = getResponse(executedAction);
  const parameters = getParameters(executedAction);
  const statusMessage = getStatusMessage(executionStatus);
  const parametersArray = Object.entries(parameters);
  const parametersList = /*#__PURE__*/_jsx("ul", {
    children: parametersArray.map(([key, value]) => /*#__PURE__*/_jsxs("li", {
      children: [/*#__PURE__*/_jsx("b", {
        children: key
      }), ': ', value]
    }, key))
  });
  return /*#__PURE__*/_jsxs(View, {
    backgroundColor: "fill-info-subtle",
    borderColor: "border-tertiary-default",
    borderWidth: "100",
    borderRadius: "200",
    borderStyle: "solid",
    marginBlockStart: "200",
    marginBlockEnd: "100",
    marginInline: "250",
    paddingBlockStart: "200",
    paddingBlockEnd: "100",
    paddingInline: "250",
    children: [/*#__PURE__*/_jsxs(Flex, {
      padding: "200",
      justifyContent: "space-between",
      inlineSize: "100%",
      children: [/*#__PURE__*/_jsx(IconHolder, {
        icon: ViewIcon,
        padding: "0",
        paddingBlockStart: "50"
      }), /*#__PURE__*/_jsx(View, {
        flexGrow: 1,
        marginInline: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'conversations-inbox-message-history.customer-agent-action-execution-message.warning'
        })
      }), /*#__PURE__*/_jsx(Tooltip, {
        placement: "left",
        title: /*#__PURE__*/_jsx(FormattedDateTime, {
          value: completedAt,
          format: "lll",
          type: "userTz"
        }),
        children: /*#__PURE__*/_jsx(FormattedDateTime, {
          value: completedAt,
          format: "LT",
          type: "userTz"
        })
      })]
    }), /*#__PURE__*/_jsxs(View, {
      marginBlockStart: "200",
      marginBlockEnd: "400",
      marginInline: "400",
      children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "conversations-inbox-message-history.customer-agent-action-execution-message.description",
        options: {
          actionName,
          executionStatus
        }
      }), ' ', parametersArray.length > 0 && /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "conversations-inbox-message-history.customer-agent-action-execution-message.parameters"
      }), parametersList, /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "conversations-inbox-message-history.customer-agent-action-execution-message.status",
        options: {
          statusMessage,
          response
        }
      })]
    })]
  });
};
const CustomerAgentActionExecutionMessage = ({
  message
}) => {
  const executedActions = getExecutedActions(message);
  return executedActions.map(actionMessage);
};
CustomerAgentActionExecutionMessage.displayName = 'CustomerAgentActionExecutionMessage';
export default CustomerAgentActionExecutionMessage;